import { motion } from "framer-motion";
import { SectionHeading } from "./Reveal";
import { ShieldHalf, Cpu, CalendarClock, Network } from "lucide-react";
import { useLang } from "@/i18n/LanguageContext";

const ICONS = [ShieldHalf, Cpu, CalendarClock, Network];

export const Mission = () => {
  const { t } = useLang();
  const chapters = t("mission.ch");

  return (
    <section id="mission" data-testid="mission-section" className="relative py-20 lg:py-28 bg-[#F8FAFC] bg-blueprint overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <SectionHeading
          eyebrow={t("mission.eyebrow")}
          title={
            <>
              {t("mission.titleA")}
              <span className="text-blue-700">{t("mission.titleB")}</span>
              {t("mission.titleC") || ""}
            </>
          }
          sub={t("mission.sub")}
        />

        <div className="border-t border-slate-200">
          {chapters.map((c, i) => {
            const Icon = ICONS[i];
            const n = `0${i + 1}`;
            return (
              <motion.div
                key={n}
                data-testid={`mission-chapter-${n}`}
                initial={{ opacity: 0, y: 44 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-60px" }}
                transition={{ duration: 0.75, delay: i * 0.08, ease: [0.22, 1, 0.36, 1] }}
                className="group grid grid-cols-12 gap-4 sm:gap-8 items-center py-9 lg:py-12 border-b border-slate-200 hover:bg-white/70 transition-colors duration-300 px-2 sm:px-4"
              >
                <div className="col-span-3 sm:col-span-2">
                  <span className="font-mono text-5xl sm:text-6xl lg:text-7xl font-extrabold tracking-tighter text-slate-200 group-hover:text-blue-600 transition-colors duration-400">
                    {n}
                  </span>
                </div>
                <div className="col-span-9 sm:col-span-6 lg:col-span-5">
                  <div className="flex items-center gap-3">
                    <Icon className="w-5 h-5 text-blue-700 shrink-0" />
                    <h3 className="text-lg sm:text-2xl font-bold text-slate-900 tracking-tight">{c.title}</h3>
                  </div>
                  <p className="mt-3 text-sm sm:text-base text-slate-500 leading-relaxed max-w-xl">{c.desc}</p>
                </div>
                <div className="hidden lg:flex col-span-5 justify-end">
                  <span className="font-mono text-[11px] font-bold tracking-[0.24em] uppercase text-slate-400 group-hover:text-emerald-700 transition-colors duration-300 border border-slate-200 group-hover:border-emerald-300 rounded-full px-4 py-2">
                    {t("mission.chapter")} {n} / 04
                  </span>
                </div>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
};
